<template>
  <div class="customer">
    <!-- <h2>客服界面</h2> -->

    <div class="customer-pic">
      <p class="head-title">客服微信</p>
      <img src="../assets/kefu.png" alt="" />
      <p class="foot-title">扫码添加</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Customer",
};
</script>

<style scoped>
.customer {
  display: flex;
  justify-content: center;
}
.customer-pic {
  width: 40%;
  height: 50%;
  text-align: center;
  margin-top: 200px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.head-title {
  font-size: 20px;
  font-weight: 600;
}
.foot-title {
  font-size: 20px;
  font-weight: 600;
}
.customer-pic img {
  width: 50%;
}
</style>